


const mappings = [
    {
        id: 'id',
        title: 'Id'
    },
    {
        id: 'status',
        title: 'Status'
    },
   
];

export default mappings;
